import { render, staticRenderFns } from "./Pontos.vue?vue&type=template&id=5340f14e"
import script from "./Pontos.vue?vue&type=script&lang=js"
export * from "./Pontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports